import React, { useRef, useEffect, useState, useMemo } from "react";
import { CountryRegionData } from "react-country-region-selector";
import { setPaymentResponse } from "globals/payments";
import { Formik, Form, Field } from "formik";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import MaskedInput from "react-text-mask/dist/reactTextMask";
import { object, string } from "yup";
import { useHistory } from "react-router";
import { Helmet } from "react-helmet";
import { getUser, getAuthState, getTransactionType, getPolicyHolders, setProgressLine } from "globals/auth";
import Card from "./Card";
import { Row, Col, Container } from "reactstrap";

import "./BillingForm.scss";
import CustomCheckbox from "components/CustomCheckbox";
import { lastDayOfMonth } from "date-fns";
import { InfoIcon } from "components";
import { QUICK_PAY } from "pages/RenewPolicy/constants";
import * as Yup from 'yup';
import CustomInput from "./CustomInput";
import CustomSelect from "./CustomSelect";
import { toast } from "react-toastify";
import FloatingLabelInput from "components/NewFloatingLabel/FloatingLabelInput";
import FloatingLabelSelect from "components/NewFloatingLabel/FloatingLabelSelect";
import logger from "utils/logger";
import AnimateContainer from "components/AnimateContainer";
import { AnimatePresence, motion } from 'framer-motion';
const { testIds } = require("testing/testIds");
// TODO: Import DotsLoader and Success components and replace the string literals below
// import DotsLoader from "components/DotsLoader";
// import Success from "components/Success";

const uuid = require("uuid").v4;

// Static image paths from public folder
const arrow = "/assets/img/arrow.png";
const EnvelopeIcon = "/assets/img/payment_form_icons/envelope.svg";
const PhoneIcon = "/assets/img/payment_form_icons/phone-call.svg";
const CreditCardIcon = "/assets/img/payment_form_icons/credit_card_icon.svg";
const GreenLockIcon = "/assets/img/payment_form_icons/green_lock.svg";
const BillingDetailsIcon = "/assets/img/payment_form_icons/file-invoice-billing-details.svg";

const gatewayURL = process.env.REACT_APP_GATEWAY_URL;
const jQueryURL = "https://code.jquery.com/jquery-1.7.2.min.js";

/** Possible form states */
const transactionStates = {
	ERROR: "error",
	DEFAULT: "default",
	LOADING: "loading",
	SUCCESS: "success",
};

/** Initializers for form state */
const defaults = {
	firstName: "",
	lastName: "",
	email: "",
	phoneNumber: "",
	billingAddress: "",
	country: "Jamaica",
	region: "",
	zip_code: "",
	cardNumber: "",
	cardName: "",
	cardExpiryMonth: "",
	cardExpiryYear: "",
	cardCVC: "",
	sameAddress: false,
};

/** Schema using the Yup library for easier field validation */
const billingFormSchema = Yup.object({
	firstName: Yup.string().required("Please enter your first name"),
	lastName: Yup.string().required("Please enter your last name"),
	email: Yup.string().required("Please enter your email address").email().trim(),
	phoneNumber: Yup.string()
		.required("Please enter your phone number")
		.matches(/^[+]?(\d{1,2})?[\s.-]?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/g, "Phone Number format is invalid"),
	billingAddress: Yup.string().required("Please enter your billing address"),
	country: Yup.string().required("Please choose your card's billing country"),
	region: Yup.string().when("country", {
		is: country => country === "Jamaica",
		then: Yup.string().required("Please choose your parish"),
	}),
	sameAddress: Yup.boolean(),
	zip_code: Yup.string(),
	cardName: Yup.string().required("Please enter the name of the cardholder"),
	//cardNumber: Yup.string().required("Card Number required").matches(/\d+/g, "Entry should be a valid number").length(19, "Invalid credit card number"),
	cardExpiryMonth: Yup.string()
		.required("Please enter your card's expiry date")
		.matches(/(0[1-9]|1[0-2])/g, `Invalid month entered, please enter a valid month from 01-12`),
	cardExpiryYear: Yup.string()
		.required("Please enter your card's expiry date")
		.matches(/\d{2}/g, `Invalid year entered, please use the last two digits of the year`)
		.test("date-not-expired", `Card is invalid or expired. Please provide a valid date.`, checkValidDate),
	//cardCVC: Yup.string().required("Please enter a valid CVC/CVV").max(4, "Please enter a valid CVC/CVV"),
});

const phoneNumberMask = ["(", /\d/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/];
const creditCardMask = [
	/\d/,
	/\d/,
	/\d/,
	/\d/,
	"-",
	/\d/,
	/\d/,
	/\d/,
	/\d/,
	"-",
	/\d/,
	/\d/,
	/\d/,
	/\d/,
	"-",
	/\d/,
	/\d/,
	/\d/,
	/\d/,
];

/**
 * Checks to ensure a valid date is provided
 * @param {String} year
 */
function checkValidDate(year) {
	if (!this.parent.cardExpiryMonth) return false;

	const dateEntry = lastDayOfMonth(new Date(parseInt(`20${year}`), this.parent.cardExpiryMonth - 1)); //Month is 0-indexed
	const currentDate = new Date();
	if (dateEntry < currentDate) return false;

	return true;
}

/** Default form state */
const defaultFormStatus = { transactionState: transactionStates.DEFAULT };

/**
 * TODO: Add to this later
 * @param {Object} props
 */
function BillingDetails({ setBillingDetails, showPaymentModal, showError, transaction, updateStep, stepPosition, confirmPayment }) {
	const dispatch = useDispatch();
	const user = useSelector(getUser, shallowEqual);
	const policyHolders = useSelector(getPolicyHolders, shallowEqual);
	const isLoggedIn = useSelector(getAuthState, shallowEqual);
	const [isHomeAdress, setIsAddress] = useState(false);
	const history = useHistory();
	const transactionType = useSelector(getTransactionType, shallowEqual);
	const formDefaults = useRef(defaults);
	/** ref is necessary to prevent re-render bug: text getting removed */
	const cardType = useRef("");
	const cardNumber = useRef(null);
	const cardName = useRef(null);
	const cardCVC = useRef(null);
	const [cardNumburDirty, setCardNumburDirty] = useState(false);
	const [cvcDirty, setCVCDirty] = useState(false);
	const [cardFieldsDirty, setCardFieldsDirty] = useState(false)
	const [country, setCountry] = useState(null);
	const [region, setregion] = useState(null);

	const [inputStatus, setInputStatus] = useState({
		cardNumber: {
			onFocus: false,
			onChange: false
		},
		cvc: {
			onFocus: false,
			onChange: false
		},
	});

	logger.log("inputStatus: ", inputStatus);
	useEffect(() => {
		if (cardNumburDirty && cvcDirty) setCardFieldsDirty(true);
	}, [cardNumburDirty, cvcDirty]);


	const countryOptions = CountryRegionData.map(([countryName, countryCode, region]) => ({
		value: countryName,
		label: countryName
	}));

	// Find selected country's region data
	const selectedCountryData = CountryRegionData.find(
		([countryName]) => countryName === country?.value
	);

	const [sessionKey, setSessionKey] = useState(0);

	const clearCardFields = () => {
	setSessionKey((prev) => prev + 1);
	};

	


	const regionOptions = selectedCountryData && selectedCountryData[2]
	? selectedCountryData[2].split('|').map((region) => {
		const [regionName] = region.split('~');
		  return { label: regionName, value: regionName };
		})
	: [];


	const handleInputChange = (selector) => {

		if (selector === "#cardCVC") setCVCDirty(true);
		if (selector === "#cardNumber") setCardNumburDirty(true);
	};
	/** Initializers for form state */
	const defaultFormValues = useMemo(() => {
		if (transactionType !== QUICK_PAY)
			return {
				...formDefaults.current,
				firstName: transaction.firstName !== null ? transaction.firstName : "",
				lastName: transaction.lastName !== null ? transaction.lastName : "",
				email:
					transactionType === QUICK_PAY && formDefaults.current.email !== null
						? formDefaults.current.email
						: transactionType !== null
							? user.email_address !== null && user.email_address !== undefined
								? user.email_address
								: ""
							: "",
				region:
					transactionType === QUICK_PAY && formDefaults.current.region !== null ? formDefaults.current.region : "",
				phoneNumber:
					transactionType === QUICK_PAY && formDefaults.current.phoneNumber !== null
						? formDefaults.current.phoneNumber
						: "",
				billingAddress:
					transactionType === QUICK_PAY && formDefaults.current.billingAddress !== null
						? formDefaults.current.billingAddress
						: "",
				fromRenewalFlow: transaction.policyNumber === null ? false : true,
			};
		else
			return {
				...formDefaults.current,
				fromRenewalFlow: false,
			};
	}, [transaction, transactionType, user]);

	const [scriptLoaded, setScriptLoaded] = useState(
		typeof window !== "undefined" && typeof window["myScript"] !== "undefined"
	);

	/**
	 * Handles script loading
	 * @param {*} _
	 * @param {*} addedTags
	 */
	const handleScriptLoadState = (_, addedTags) => {
		if (addedTags && addedTags.scriptTags) {
			const foundScript = addedTags.scriptTags.find(({ src }) => src === gatewayURL);
			if (foundScript) {
				foundScript.addEventListener("load", () => setScriptLoaded(true), { once: true });
			}
		}
	
		window.PaymentSession?.onFocus(['card.number'], function (selector) {
			handleInputChange(selector);
			
		});
	
		
		window.PaymentSession?.onFocus(['card.securityCode'], function (selector) {
			handleInputChange(selector);
			
		})
	
	};

	/**
	 * Handles the submission of the form
	 * @param {defaultFormValues} values
	 */
	async function handleFormSubmit(values) {
		setBillingDetails(values);
		window.PaymentSession.updateSessionFromForm("card");
	}

	/**
	 * Additional name validation if coming from renewal flow
	 * @param {String} value
	 */
	function validateName(value) {

		if (!value) return;
		if (!policyHolders?.length || Object.keys(user || {}).length === 0) return;
		let error;
		if (Object.keys(user).length === 0 || policyHolders?.length === 0) return error;
		let _value = value.toLowerCase().trim();

		// dont validate if user is a corporate client
		if (user?.is_a_company) return;

		const foundPolicyHolder = policyHolders.find(policyHolderObject => {

			const policyHolder = policyHolderObject.global_name;

			if (_value === `${policyHolder?.first_name?.toLowerCase().trim()} ${policyHolder?.last_name?.toLowerCase().trim()}`)
				return policyHolder;
		});

		if (!foundPolicyHolder)
			error = "Name does not match Policy Holder";

		return error;
	}
 
	useEffect(() => {
		if (scriptLoaded) {
			if (window.self === window.top) {
				let antiClickjack = document.getElementById("antiClickjack");
				if (antiClickjack) antiClickjack.parentNode.removeChild(antiClickjack);
			} else {
				window.top.location = window.self.location;
			}

			window.PaymentSession.configure({
				fields: {
					// ATTACH HOSTED FIELDS TO YOUR PAYMENT PAGE FOR A CREDIT CARD
					card: {
						number: "#cardNumber",
						securityCode: "#cardCVC",
						expiryMonth: "#cardExpiryMonth",
						expiryYear: "#cardExpiryYear",
					},
				},
				//SPECIFY YOUR MITIGATION OPTION HERE
				frameEmbeddingMitigation: ["javascript"],
				callbacks: {
					initialized: function (response) {
						// HANDLE INITIALIZATION RESPONSE
					},
					formSessionUpdate: function (response) {
						// HANDLE RESPONSE FOR UPDATE SESSION
						if (response.status) {
							if (response.status === "ok") {
								//("Session updated with data: " + response.session.id, response);
								dispatch(setPaymentResponse({ session: response.session, sourceOfFunds: response.sourceOfFunds }));
								showPaymentModal(true);

								//check if the security code was provided by the user
								// if (response.sourceOfFunds.provided.card.securityCode) {
								// }

								// if (response.sourceOfFunds.provided.card.number) {
								// }

								//check if the user entered a MasterCard credit card
								// if (response.sourceOfFunds.provided.card.scheme === "MASTERCARD") {
								// }
							} else if ("fields_in_error" === response.status) {
								const error = Object.keys(response.errors).reduce(
									(errorStr, label) =>
										`${label.toLowerCase()} is ${response.errors[label]}${errorStr.length ? `, ${errorStr}` : ""}`,
									""
								);
								showError(`Oops! Unable to process payment: ${error}`);
							} else if ("request_timeout" === response.status) {
								showError(`Oops! Unable to process payment. Took too long`);
							} else if ("system_error" === response.status) {
								showError(`Oops! Unable to process payment. A problem arose.`);
							}
						}
						// else {
						// }
					},
				},
			});
			setScriptLoaded(false);
		}

		// React 19 requires a cleanup function or explicit return
		return () => {
			// Cleanup if needed when component unmounts or dependencies change
		};
	}, [scriptLoaded, dispatch, showPaymentModal, showError]);

	console.log("QUICK_PAY: ", stepPosition);

	return (
		<>
			<Formik
				initialStatus={defaultFormStatus}
				initialValues={defaultFormValues}
				enableReinitialize
				validationSchema={billingFormSchema}
				validateOnFocus={true}
				onSubmit={handleFormSubmit}
			>
				{({ resetForm, isSubmitting, errors, values, touched, setFieldTouched, status, isValid, handleChange, submitForm, dirty, setFieldValue, setFieldError }) => (
					<>
						{((transactionType === QUICK_PAY && (stepPosition.step === 2 || stepPosition.step === 3) ) || transactionType != QUICK_PAY ) && (
							
							<div className={`${transactionType === QUICK_PAY ? (stepPosition.lastRequest === "back" ? "custom-fade-in-right" : "custom-fade-in-left") : "" }`} >
							 <>
							 {console.log("errors: ", errors.email)}
								<div key={stepPosition.step} id="billing-details-card--" className="billing-details-card"> 
									<div className="wrap-form">
										<div className="section-header billing-header">
											<span className="section-icon">
												<img src={BillingDetailsIcon} alt="" style={{ width: 32, height: 32 }} />
											</span>
											<span className="section-title">Billing Details</span>
										</div> 
											<Form key={stepPosition} className="form billing" style={{background:"transparent", borderRadius: "0px", padding: "0"}}>
												{/** @type {First Name & Last Name} */}
												{(stepPosition.step == 2 && (transactionType === QUICK_PAY ) || (transactionType != QUICK_PAY )) ? (
														<div className={`${transactionType === QUICK_PAY ? (stepPosition.lastRequest === "back" ? "custom-fade-in-right" : "custom-fade-in-left") : "" }`} >
															<>
																<Row>
																	<Col md={6} style={{marginTop: "0px", marginBottom: "10px", height: "80px"}}>
																		<FloatingLabelInput
																			as="input"
																			id="firstName"
																			className="outlined-input"
																			label={
																				<div style={{ whiteSpace: "nowrap" }}>
																					<span className="field-title">First Name</span>
																					<span className="required"> * </span>
																				</div>
																			}
																			value={values.firstName}
																			onChange={e => setFieldValue("firstName", e.target.value)}
																			onBlur={() => setFieldTouched("firstName", true)}
																			type="text"
																			disabled={values.fromRenewalFlow && !user?.is_a_company}
																			error={errors.firstName}
																			touched={touched.firstName}
																			required
																		/>
																	</Col>
																	<Col md={6} style={{marginTop: "0px", marginBottom: "10px", height: "80px"}}>
																		{/** @type {Last Name} */}
																		<FloatingLabelInput
																			as="input"
																			id="lastName"
																			className="outlined-input"
																			label={
																				<div style={{ whiteSpace: "nowrap" }}>
																					<span className="field-title">Last Name</span>
																					<span className="required"> * </span>
																				</div>
																			}
																			value={values.lastName}
																			onChange={e => setFieldValue("lastName", e.target.value)}
																			onBlur={() => setFieldTouched("lastName", true)}
																			type="text"
																			disabled={values.fromRenewalFlow && !user?.is_a_company}
																			error={errors.lastName}
																			touched={touched.lastName} 
																			required
																		/>
																	</Col>
																</Row>
																{/** @type {Email} */}
																<Row >
																	<Col md={12} style={{marginTop: "0px", marginBottom: "10px", height: "80px"}}>
																		<FloatingLabelInput
																			as="input"
																			id="email"
																			className="outlined-input"
																			label={
																				<div style={{ whiteSpace: "nowrap" }}>
																					<span className="field-title">Email Address</span>
																					<span className="required"> * </span>
																				</div>
																			}
																			value={values.email}
																			onChange={e => setFieldValue("email", e.target.value)}
																			onBlur={() => setFieldTouched("email", true)}
																			type="text"
																			disabled={values.fromRenewalFlow}
																			error={errors.email}
																			touched={touched.email} 
																			leftIcon={<img src={EnvelopeIcon} alt="" style={{ width: 20, height: 20 }} />}
																			required
																		/>
																	</Col>
																</Row>

																{(transactionType == QUICK_PAY) &&
																<div className="payment-button-container">
																	<button
																		className={
																			`button-v2 back-theme-btn`
																		}
																		onClick={() => {
																			confirmPayment(false);
																			updateStep(1, 'back'); 
																			location.reload(true);
																		}}
																	>
																		{"Cancel"}
																	</button>
																	<button
																		className={
																			`button-v2 primary-theme-btn`
																		}
																		disabled={
																			values.firstName == "" ||
																			values.lastName == "" ||
																			values.email == "" || 
																			errors.firstName != undefined ||
																			errors.lastName != undefined ||
																			errors.email != undefined
																		}
																		onClick={() => {
																			updateStep(3, 'fwd')
																		}}
																	>
																		{"Confirm"}
																	</button>
																</div>}
															</>
														</div>
												) : null }

												{(transactionType != QUICK_PAY) &&
												<Row className="pt-0 pb-5">
													<Col>
														{isLoggedIn && transactionType !== QUICK_PAY && (
															<div
																style={{
																	display: "flex",
																	flexDirection: "row",
																	alignItems: "center",
																	backgroundColor: "#f5f5f5",
																	borderRadius: "8px",
																	padding: "16px 20px",
																	color: values.sameAddress ? "#333333" : "#666666",
																	fontWeight: "400",
																}}
															>
																<Field
																	name="sameAddress"
																	type="checkbox"
																	value={values.sameAddress}
																	onFocus={(e) => {
																		handleChange(e);

																		setFieldError('billingAddress', '');
																		setFieldError('phoneNumber', '');
																		setFieldError('region', '');

																	}}

																>
																	{({ field }) => (

																		<CustomCheckbox
																			{...field}
																			className="mb-0"
																			onClick={() => {
																				const streetAddress = [
																					user.locations[0]?.street_number,
																					user.locations[0]?.street_name,
																					user.locations[0]?.street_type
																				].filter(Boolean).join(" ");
																				if(
																					streetAddress.trim().length !== 0
																					&& (user.phone_numbers[0]?.phone_number !== null && user.phone_numbers[0]?.phone_number.length !== 0)
																					&& (user?.locations[0]?.parish !== null && user?.locations[0]?.parish.length !== 0)
																				){

																					setFieldValue("sameAddress", !values.sameAddress);
																					setFieldValue(
																						"billingAddress",
																						!values.sameAddress ? streetAddress : ""
																					);

																					setFieldValue(
																						"phoneNumber",
																						user.phone_numbers[0]?.phone_number !== null && !values.sameAddress
																							? user?.phone_numbers?.[0]?.phone_number
																							: ""
																					);

																					setFieldValue(
																						"region",
																						user?.locations[0]?.parish !== null && !values.sameAddress
																							? user?.locations[0]?.parish.includes("St.")
																								? user?.locations[0]?.parish.replaceAll("St.", "Saint")
																								: user?.locations[0]?.parish
																							: ""
																					);
																				} else {
																					toast.error("We encountered an error retrieving your information. Please enter the details manually.");
																				}
																			}}

																			checked={values.sameAddress}
																		/>
																	)}
																</Field>

																<span style={{ marginLeft: "12px", fontSize: "14px", lineHeight: "20px" }}>
																	My billing address is the same as my home address
																</span>
															</div>
														)}
													</Col>
												</Row>}

												{(stepPosition.step == 3 && (transactionType === QUICK_PAY ) || (transactionType != QUICK_PAY ))  && ( 
													<div className={`${transactionType === QUICK_PAY ? (stepPosition.lastRequest === "back" ? "custom-fade-in-right" : "custom-fade-in-left") : "" }`} >
														<>
															<Row>
																<Col style={{marginTop: "0", marginBottom: "10px", height: "80px"}} md={8}>
																	{/** @type {Address} */}
																	<FloatingLabelInput
																		as="input"
																		id="billingAddress"
																		className="outlined-input"
																		label={
																			<div style={{ whiteSpace: "nowrap" }}>
																				<span className="field-title">Billing Address</span>
																				<span className="required"> * </span>
																			</div>
																		}
																		value={values.billingAddress}
																		onChange={e => setFieldValue("billingAddress", e.target.value)}
																		onBlur={(e) => {
																			if (e.target.value !== "") {
																				//formDefaults.current.billingAddress = e.target.value;
																				setFieldValue("billingAddress", e.target.value);
																			}
																			setFieldTouched("billingAddress", true, true)
																		}}
																		type="text"
																		disabled={values.sameAddress}
																		error={errors.billingAddress}
																		touched={touched.billingAddress}
																		inputHighlight={values.sameAddress}
																		required
																	/>
																</Col> 
																<Col style={{marginTop: "0", marginBottom: "10px", height: "80px"}} md={4}>
																	{/** @type {Country} */}
																	<FloatingLabelSelect
																		id="country"
																		name="country"
																		label={
																			<div style={{ whiteSpace: "nowrap" }}>
																				<span className="field-title">Country</span>
																				<span className="required"> * </span>
																			</div>
																		}
																		options={countryOptions}
																		value={values.sameAddress ?
																			[ { value: values.country, label: values.country } ] : country}
																		placeholder="Select..."
																		onChange={(selectedCountry) => {
																			setFieldValue("country", selectedCountry.value);
																			setCountry(selectedCountry);
																			setregion(null);
																		}}
																		error={errors.country}
																		onBlur={() => setFieldTouched("country", true)}
																		isInvalid={values?.country?.length == 0}
																		isDisabled={values.sameAddress}
																		inputHighlight={values.sameAddress}
																		required
																	/>
																	{/* <FloatingLabelInput
																		as="select"
																		id="country"
																		inputType="country"
																		label={
																			<div style={{ whiteSpace: "nowrap" }}>
																				<span className="field-title">Country</span>
																				<span className="required"> * </span>
																			</div>
																		}
																		className="outlined-input"
																		value={values.country}
																		onChange={(_, e) => {
																			handleChange(e)

																			if (e.target.value !== "")
																				//formDefaults.current.country = e.target.value;
																				setFieldValue("country", e.target.value);
																		}}
																		onBlur={() => setFieldTouched("country", true)}
																		disabled={values.sameAddress}
																		error={errors.country}
																		required
																	/>
																	*/}
																	{/* {touched.country && errors.country && (
																		<div className="text-danger pt-2 pl-2">{errors.country}</div>
																	)} */}
																</Col>
															</Row>
															<Row>
																<Col style={{marginTop: "0", marginBottom: "10px", height: "80px"}} md={4}>
																	{/** @type {Province} */}
																	<FloatingLabelSelect
																		id="region"
																		name="region"
																		label={
																			values.country === "Jamaica" ?
																			<div style={{ whiteSpace: "nowrap" }}>
																				<span className="field-title">Parish</span>
																				<span className="required"> * </span>
																			</div> : <div style={{ whiteSpace: "nowrap" }}>
																				<span className="field-title">Province</span>
																				<span className="required"> * </span>
																			</div>
																		}
																		options={regionOptions}
																		value={values.sameAddress ?
																			[ { value: values.country, label: values.region } ] : region}
																		placeholder="Select..."
																		onChange={(selectedRegion) => {
																			setFieldValue("region", selectedRegion.value);
																			setregion(selectedRegion);
																		}}
																		error={errors.region} 
																		// touched={touched.region}
																		// isInvalid={values?.region?.length == 0}
																		// edited={touched.region && values?.region?.length}
																		onBlur={() => setFieldTouched("region", true)}
																		isDisabled={values.sameAddress} 
																		required
																	/>


																	{/* {touched.region && errors.region && (
																		<div className="text-danger pt-2 pl-2">{errors.region}</div>
																	)} */}
																</Col>
																<Col style={{marginTop: "0", marginBottom: "10px", height: "80px"}} md={4}>
																	{/** @type {ZIP Code} */}
																		<FloatingLabelInput
																			as="input"
																			id="zip_code"
																			label={
																				<div style={{ whiteSpace: "nowrap" }}>
																					<span className="field-title">ZIP Code</span>
																				</div>
																			}
																			className="outlined-input"
																			value={values.zip_code}
																			type="text"
																			onChange={(e) => {
																				handleChange(e);
																				if (e.target.value !== "")
																					//formDefaults.current.region = e.target.value;
																					setFieldValue("zip_code", e.target.value);

																			}}
																			onBlur={() => setFieldTouched("zip_code", true)}
																			disabled={values.sameAddress}
																			error={errors.zip_code}
																			touched={touched.zip_code}
																			inputHighlight={values.sameAddress}
																			required
																		/>
																</Col>
																<Col style={{marginTop: "0", marginBottom: "10px", height: "80px"}} md={4}>
																	{/** @type {Phone Number} */}
																	<FloatingLabelInput
																		as="input"
																		id="phoneNumber"
																		mask={phoneNumberMask}
																		inputType="mask"
																		label={
																			<div style={{ whiteSpace: "nowrap" }}>
																				<span className="field-title">Phone Number</span>
																				<span className="required"> * </span>
																			</div>
																		}
																		className="outlined-input"
																		value={values.phoneNumber}
																		type="text"
																		onChange={(e) => {
																			handleChange(e)
																			if (e.target.value !== "")
																				setFieldValue("phoneNumber", e.target.value);

																		}}
																		onBlur={() => setFieldTouched("phoneNumber", true)}
																		disabled={values.sameAddress}
																		error={errors.phoneNumber}
																		touched={touched.phoneNumber}
																		inputHighlight={values.sameAddress}
																		leftIcon={<img src={PhoneIcon} alt="" style={{ width: 18, height: 18 }} />}
																		required
																	/>
																</Col>
															</Row>
															{(transactionType == QUICK_PAY) &&
															<div className="payment-button-container">
																<button
																	className={
																		`button-v2 back-theme-btn`
																	}
																	onClick={() => {
																		confirmPayment(false);
																		updateStep(2, 'back')
																	}}
																>
																	{"Back"}
																</button>
																<button
																	className={
																		`button-v2 primary-theme-btn`
																	}
																	disabled={
																		values.billingAddress == "" ||
																		country == undefined ? true : Object.keys(country).length == 0 ||
																		region == undefined ? true : Object.keys(region).length == 0 ||
																		values.phoneNumber == "" ||
																		errors.billingAddress != undefined ||
																		errors.phoneNumber != undefined
																	}
																	onClick={() => { 
																		updateStep(4, 'fwd')
																	}}
																>
																	{"Confirm"}
																</button>
															</div>}
														</>
													</div>
												)}
											</Form> 
									</div> 
								</div>
							</>
							</div>
						)}
						
						{/* <motion.div 
							
							initial={{ opacity: 0, x: -50 }}
							animate={{ opacity: 1, x: 0 }}
							exit={{ opacity: 0, x: 50 }}
							transition={{ duration: 0.5 }}
						> */}
							<div 
								id="card-details-card--" 
								className={`card-details-card ${transactionType === QUICK_PAY && stepPosition.step === 4 ? (stepPosition.lastRequest === "back" ? "custom-fade-in-right" : "custom-fade-in-left") : "" }`}
								style={{ 
									overflow:"visible",
									height: ((transactionType === QUICK_PAY && stepPosition.step === 4 ) || transactionType != QUICK_PAY) ? "100%" : "0",
									overflow: ((transactionType === QUICK_PAY && stepPosition.step === 4 ) || transactionType != QUICK_PAY) ? "visible" : "hidden",
									padding: ((transactionType === QUICK_PAY && stepPosition.step === 4 ) || transactionType != QUICK_PAY) ? "30px" : 0,
									pointerEvents: ((transactionType === QUICK_PAY && stepPosition.step === 4 ) || transactionType != QUICK_PAY) ? "auto" : "none"
								}}
							>
								<div className="wrap-form p-0">

									<div className="section-header card-heading">
										<div className="section-header-left">
											<span className="section-icon card-icon">
												<img src={CreditCardIcon} alt="" style={{ width: 32, height: 32 }} />
											</span>
											<span className="section-title">Card Details</span>
										</div>
										<div className="section-header-right">
											<Card type={cardType.current} />
										</div>
									</div>


									<Form
										key={sessionKey}
										className="form cc card-payment"
										style={{ padding:"0", background:"transparent", borderRadius: "0px" }}
										data-testid={testIds.renewal.cardPayment.form.container}
									>
										<Container style={{ padding: 0 }}>
										{/* Card Number and Name on Card - Side by Side */}
										<Row className="justify-content-between">
											<Col md={6} style={{ marginTop: "0", marginBottom: "10px", height: "80px" }}>
												{/** @type {Credit Card Number} */}
												<div className="cc-input-wrapper" data-testid={testIds.renewal.cardPayment.form.cardNumberInput}>
													<div className="cc-floating-label">
														<span className="field-title" style={{ color: inputStatus.cardNumber.onFocus ? "#333333" : "#006485" }}>Card Number</span>
														<span className="required"> * </span>
													</div>
													<div
														className="cc-iframe-container"
														style={{
															"--border-status": inputStatus.cardNumber.onFocus
																? "1.5px solid #999999"
																: "1.5px solid #c4c4c4"
														}}
													>
														<span className="cc-left-icon">
															<img src={CreditCardIcon} alt="" style={{ width: 20, height: 20 }} />
														</span>
														<Field
															type="text"
															className={`field cc-number ${isSubmitting ||
																status.transactionState === transactionStates.LOADING ||
																status.transactionState === transactionStates.SUCCESS
																? "locked"
																: ""
																}`}
															innerRef={cardNumber}
															maxLength={16}
														>
															{({ field }) => (
																<MaskedInput
																	id="cardNumber"
																	{...field}
																	value={values.cardNumber}
																	mask={creditCardMask}
																	guide={false}
																	tabIndex="0"
																	readOnly
																/>
															)}
														</Field>
														<span className="cc-right-icon">
															<img src={GreenLockIcon} alt="" style={{ width: 20, height: 20 }} />
														</span>
													</div>
												</div>
											</Col>
											<Col md={6} style={{ marginTop: "0", marginBottom: "10px", height: "80px" }} data-testid={testIds.renewal.cardPayment.form.cardholderNameInput}>
												{/** @type {Name on Card} */} 
												<Field name="cardName" validate={validateName}>
													{() => (
														<FloatingLabelInput
															as="input"
															id="cardholderName"
															name="cardName"
															type="text"
															tabIndex="0"
															error={errors.cardName}
															touched={touched.cardName}
															value={values.cardName}
															onChange={e => setFieldValue("cardName", e.target.value)}
															onBlur={() => setFieldTouched("cardName", true, true)}
															label={
																<div style={{ whiteSpace: "nowrap" }}>
																	<span className="field-title">Name on Card</span>
																	<span className="required"> * </span>
																</div>
															}
														/>

)}
													
												</Field>
													

											</Col>
										</Row>

										{/* CVC and Expiration Date - Side by Side */}
										<Row className="justify-content-between">
											<Col md={6} className="responsive-spacer" style={{ marginTop: "0", marginBottom: "10px", height: "80px" }}>
												{/** @type {Card CVC} */}
												<div className="cc-input-wrapper" data-testid={testIds.renewal.cardPayment.form.cvvInput}>
													<div className="cc-floating-label">
														<span className="field-title" style={{ color: inputStatus.cvc.onFocus ? "#333333" : "#006485" }}>CVC</span>
														<span className="required"> * </span>
														<InfoIcon label="The CVV/CVC code refers to the 3 digit number located on the back of your credit/debit card" />
													</div>
													<div
														className="cc-iframe-container"
														style={{
															"--border-status": inputStatus.cvc.onFocus
																? "1.5px solid #999999"
																: "1.5px solid #c4c4c4"
														}}
													>
														<Field
															type="password"
															id="cardCVC"
															autoComplete="cc-csc"
															value={values.cardCVC}
															maxLength={cardType.current === "american-express" ? 4 : 3}
															className={`input-field ${isSubmitting ||
																status.transactionState === transactionStates.LOADING ||
																status.transactionState === transactionStates.SUCCESS
																? "locked"
																: ""
																}`}
															disabled={
																isSubmitting ||
																status.transactionState === transactionStates.LOADING ||
																status.transactionState === transactionStates.SUCCESS
															}
															innerRef={cardCVC}
															tabIndex="0"
															readOnly
														/>
													</div>
												</div>
											</Col>
											<Col md={6} className="responsive-spacer" style={{ marginTop: "0", marginBottom: "10px", minHeight: "80px" }}>
												{/** @type {Expiry Date} */}
												<div className="cc-expiry-wrapper" data-testid={testIds.renewal.cardPayment.form.expiryDateInput}>
													<div className="expiry-fields-wrapper">
														<div className="expiryMonthFieldGroup">
															<div className="cc-expiry-label">
																<span className="field-title">Expiration Date</span>
																<span className="required"> * </span>
															</div>
															<Field
																as="select"
																id="cardExpiryMonth"
																value={values.cardExpiryMonth}
																className={`expiryMonthField ${values.cardExpiryMonth !== "" ? " --hasValue" : ""}
																	${(touched.cardExpiryMonth) && (errors.cardExpiryMonth)
																		? " --hasError"
																		: ""
																	}`
																}
																tabIndex="0"
																onChange={e => {
																	setFieldValue("cardExpiryMonth", e.target.value);
																}}
																onBlur={() => {
																	setFieldTouched("cardExpiryMonth", true, true)
																}}
															>
																<option value="">MM</option>
																<option value="01">01</option>
																<option value="02">02</option>
																<option value="03">03</option>
																<option value="04">04</option>
																<option value="05">05</option>
																<option value="06">06</option>
																<option value="07">07</option>
																<option value="08">08</option>
																<option value="09">09</option>
																<option value="10">10</option>
																<option value="11">11</option>
																<option value="12">12</option>
															</Field>
														</div>
														<div className="field-divider"></div>
														<div className="expiryYearFieldGroup">
															<Field
																as="select"
																id="cardExpiryYear"
																value={values.cardExpiryYear}
																className={`expiryYearField ${values.cardExpiryYear !== "" ? "--hasValue" : ""}
																	${(touched.cardExpiryYear || touched.cardExpiryMonth) &&
																		(errors.cardExpiryMonth || errors.cardExpiryYear)
																		? " --hasError"
																		: ""
																	}`
																}
																tabIndex="0"
																onChange={e => {
																	setFieldValue("cardExpiryYear", e.target.value);
																}}
																onBlur={() => {
																	setFieldTouched("cardExpiryYear", true, true)
																}}
															>
																<option value="">YY</option>
																{Array.from({ length: 11 }, (_, i) => {
																	const year = new Date().getFullYear() + i;
																	const shortYear = String(year).slice(-2);
																	return <option key={year} value={shortYear}>{shortYear}</option>;
																})}
															</Field>
														</div>
													</div>
													{(touched.cardExpiryMonth && errors.cardExpiryMonth && (
														<div className="errorText">{errors.cardExpiryMonth}</div>
													)) ||
														(touched.cardExpiryYear && errors.cardExpiryYear && (
															<div className="errorText">{errors.cardExpiryYear}</div>
														))}
												</div>
											</Col>
										</Row>
										</Container>
									</Form>
								</div>
								{(transactionType == QUICK_PAY) &&
								<div className="payment-button-container">
									<button
										className={
											`button-v2 back-theme-btn`
										}
										onClick={() => {
											updateStep(3, 'back')
										}}
									>
										{"Back"}
									</button>
									<button
										className={
											`button-v2 primary-theme-btn`
										}
										onClick={submitForm}
										disabled={
											!cardFieldsDirty || !(isValid && dirty) || isSubmitting

										}
										data-isloading={status.transactionState === transactionStates.LOADING}
										data-success={status.transactionState === transactionStates.SUCCESS}
										tabIndex={0}
									>
										Pay Now
									</button>
								</div>}
							</div>
						{/* </motion.div> */}
						
						{transactionType != QUICK_PAY && <div className="pay-now-wrapper" style={{ marginTop: "20px" }}>
							{transactionType && (
								<button 
									className="button-v2 text-theme-btn back-btn" 
									onClick={() => {
										history.goBack();
										dispatch(setProgressLine({													
											enabled: true,													
											percentage: 60,
										}));
									}}
								>
									Back
								</button>
							)}

							<button
								className="button-v2 primary-theme-btn"
								type="submit"
								onClick={submitForm}
								disabled={
									!cardFieldsDirty || !(isValid && dirty) || isSubmitting

								}
								data-isloading={status.transactionState === transactionStates.LOADING}
								data-success={status.transactionState === transactionStates.SUCCESS}
								data-testid={testIds.renewal.cardPayment.actions.payNowButton}
								tabIndex={0}
							>
								{(status.transactionState === transactionStates.DEFAULT ||
									status.transactionState === transactionStates.ERROR) &&
									`Pay Now`}
								{status.transactionState === transactionStates.LOADING && "<DotsLoader />"}
								{status.transactionState === transactionStates.SUCCESS && "<Success />"}
							</button>
						</div>}
					</>
				)}
			</Formik>
			<Helmet onChangeClientState={handleScriptLoadState}>
				{typeof window !== "undefined" && typeof window["myScript"] === "undefined" && (
					<script async defer src={gatewayURL}></script>
				)}
				{typeof window !== "undefined" && typeof window["myScript"] === "undefined" && (
					<script async defer src={jQueryURL}></script>
				)}
				{typeof window !== "undefined" && typeof window["myScript"] === "undefined" && (
					<style id="antiClickjack">
						{`{body {
								display: none !important;
							}`}
					</style>
				)}
			</Helmet>
		</>
	);
}

export default BillingDetails;
